/**
 * author andre.pitombeira
 */
/** @ngInject */
export default function runBlock(
  $rootScope,
  $state,
  $stateParams,
  $window,
  sessionService,
  AuthenticationService,
  NotificationService,
  ERROR_MSG,
  $timeout,
  $uibModalStack,
) {
  var navStart,
    domLoaded,
    pageRendered,
    transactionName = window.location.hash
      .substring(1)
      .replace(/\/[0-9]+\//g, '/*/')
      .replace(/\/[0-9]+$/, '/*');

  $rootScope.$state = $state;
  $rootScope.$stateParams = $stateParams;

  $rootScope.$on('$stateChangeStart', function(event, next) {
    var authorizedPermissions, authorizedRoles;

    navStart = +new Date();

    $uibModalStack.dismissAll('State Changed');

    if (angular.isDefined($window.NREUM) && angular.isFunction($window.NREUM.setPageViewName)) {
      $window.NREUM.setPageViewName(transactionName);
    }

    if (next.data && next.data.authorizedPermissions) {
      authorizedPermissions = next.data.authorizedPermissions;

      if (!sessionService.hasPermission(authorizedPermissions)) {
        event.preventDefault();

        if (AuthenticationService.isAuthenticated) {
          $state.go('app.dashboard');
          NotificationService.error(ERROR_MSG.FORBIDDEN);
        } else {
          $state.go('auth.signin');
          NotificationService.error(ERROR_MSG.UNAUTHORIZED);
        }
      }
    }

    if (next.data && next.data.authorizedRoles) {
      authorizedRoles = next.data.authorizedRoles;

      if (!sessionService.hasRole(authorizedRoles)) {
        event.preventDefault();

        if (AuthenticationService.isAuthenticated) {
          $state.go('app.dashboard');
          NotificationService.error(ERROR_MSG.FORBIDDEN);
        } else {
          $state.go('auth.signin');
          NotificationService.error(ERROR_MSG.UNAUTHORIZED);
        }
      }
    }

    //Trick to handle async code and hide the loading bar
    $timeout(function() {
      $rootScope.$broadcast('ui-butterbar.hide');
    });
  });

  $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState) {
    domLoaded = +new Date();
  });

  $rootScope.$on('$viewContentLoaded', function(event) {
    pageRendered = +new Date();

    if (angular.isDefined($window.NREUM) && angular.isFunction($window.NREUM.inlineHit)) {
      // For free version deprecated - When pay play with the addAppPage
      // https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-apis/javascript-api-deprecated
      // This does not send the transactionName as url and appears as http://local-admin.quandoo.com/
      $window.NREUM.inlineHit(
        transactionName, //request_name
        0, //queue_time
        0, //app_time
        0, //total_be_time
        domLoaded - navStart, //dom_time
        pageRendered - navStart, //fe_time
      );
    }
  });
}



// WEBPACK FOOTER //
// ./src/app/app.run.js